module.exports = __webpack_public_path__ + "static/media/bgi_d_salary_levels.bc932f8e.png";